export const MODALS = {
  LOGIN: "login",
  SIGN_UP: "signUp",
  SIGN_UP_WITH_EMAIL: "signUpWithEmail",
  VERIFY_EMAIL: "verifyEmail",
  FORGOT_PASSWORD: "forgotPassword",
  RESET_PASSWORD: "resetPassword",
  VERIFY_BIRTHDATE: "verifyBirthdate",
};
